<template>
  <div class="section">
    <div class="center-section">
      <div class="form-heading">
        <h1 class="header-1">{{ $t('auth.reset.checkEmail') }}</h1>
        <p class="caption">
          {{ $t('auth.reset.checkEmailDescription') }}
        </p>
      </div>

      <div class="login-link caption">
        <router-link :to="fromProfile ? '/profile' : '/login'" class="link">
          {{ fromProfile ? $t('auth.reset.backToProfile') : $t('auth.reset.backToLogin') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";

const route = useRoute();
const fromProfile = route.query.fromProfile === "true";
</script>

<style scoped>
.section {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-xl);
}

.center-section {
  width: 35%;
  min-width: 300px;
}

.form-heading {
  text-align: center;
  margin-bottom: var(--spacing-lg);
}

.form-heading h1 {
  margin-bottom: var(--spacing-md);
}

.form-heading .caption {
  color: var(--color-white-40);
  margin: 0 auto;
  max-width: var(--max-width-notification);
}

.login-link {
  text-align: center;
  color: var(--color-white-40);
}

.link {
  color: var(--color-white);
  text-decoration: none;
  transition: opacity var(--transition-fast);
}

.link:hover {
  opacity: 0.8;
}

@media (max-width: 768px) {
  .center-section {
    width: 90%;
  }
}
</style>
